// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3tode","disabled":"FileBtn_disabled__35ptx","warn":"FileBtn_warn__Lw10S","fade":"FileBtn_fade__2J2Hp"};